/* ==========================================================================
   Green Hills Coffee — capa UX (ghc-ux)
   Config en window.GHC_UX (snippets/ghc-ux.liquid). Sin dependencias.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.GHC_UX || {};
  var doc = document;
  var root = doc.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var isMobile = function () { return window.matchMedia('(max-width: 1024px)').matches; };

  function store(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  function onScrollFrame(fn) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { fn(); ticking = false; });
    }, { passive: true });
    fn();
  }

  /* ------------------------------------------------------------------------
     1. Barra de progreso de lectura
     ------------------------------------------------------------------------ */
  function initProgress() {
    var el = doc.querySelector('[data-ghc-progress]');
    if (!el) return;
    onScrollFrame(function () {
      var max = root.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      el.style.setProperty('--ghc-p', p.toFixed(4));
    });
  }

  /* ------------------------------------------------------------------------
     2. Barra CTA móvil/tablet (siempre visible). En desktop el CTA está en el header.
     ------------------------------------------------------------------------ */
  function initCta() {
    var cta = doc.querySelector('[data-ghc-cta]');
    if (!cta) return;

    var isPdp = cta.classList.contains('ghc-cta--pdp');
    root.classList.add('ghc-cta-on');
    doc.body.classList.add('ghc-has-cta');

    // En producto la barra solo ocupa espacio cuando está visible
    var setHeight = function () {
      var shown = isPdp ? cta.classList.contains('is-visible') : isMobile();
      root.style.setProperty('--ghc-cta-h', shown ? cta.offsetHeight + 'px' : '0px');
    };
    setHeight();
    window.addEventListener('resize', setHeight, { passive: true });

    // Producto: la barra dispara el "Agregar al carrito" del formulario principal
    // (respeta variante, cantidad y el drawer del carrito del theme).
    var atc = cta.querySelector('[data-ghc-cta-atc]');
    if (!atc) return;
    var mainAtc = function () {
      return doc.querySelector('#MainContent [data-atc-btn]') ||                          // fnc-cafe-pdp
             doc.querySelector('#MainContent .t4s-product-form__submit[data-atc-form]') ||  // main-product del theme
             doc.querySelector('#MainContent form[action*="/cart/add"] [type="submit"]');
    };
    atc.addEventListener('click', function () {
      var btn = mainAtc();
      if (!btn) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
        btn.scrollIntoView({ behavior: 'smooth', block: 'center' });   // falta elegir variante / agotado
        return;
      }
      btn.click();
    });

    // Mantener precio y disponibilidad sincronizados con la variante elegida
    var label = atc.querySelector('span:not([data-ghc-cta-price])');
    var price = atc.querySelector('[data-ghc-cta-price]');
    var sync = function () {
      var btn = mainAtc();
      if (!btn) return;
      var off = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      atc.classList.toggle('is-off', off);
      var txt = btn.querySelector('.t4s-btn-atc_text, [data-atc-label]');
      if (txt && label) label.textContent = txt.textContent.split('·')[0].trim();
      var vt = cta.querySelector('[data-ghc-cta-variant]');
      var form = btn.form || btn.closest('form');
      if (vt && form) {
        var names = [];
        form.querySelectorAll('input[type="radio"]:checked, select').forEach(function (i) {
          if (i.name && i.name !== 'id' && i.name.indexOf('properties') !== 0) names.push(i.tagName === 'SELECT' ? i.options[i.selectedIndex].text : i.value);
        });
        if (names.length) vt.textContent = names.join(' · ');
      }
      var sec = btn.closest('.shopify-section') || doc;
      var p = sec.querySelector('[data-atc-price], [data-price-now], .t4s-product-price');
      if (price && p) {
        var cur = (p.querySelector('ins') || p).textContent.trim().split(/\s{2,}/)[0];
        if (cur) price.textContent = cur;
      }
    };
    var target = mainAtc();
    if (target) new MutationObserver(sync).observe(target, { attributes: true, childList: true, subtree: true, characterData: true });

    // Desktop: aparece al hacer scroll, cuando el botón de la ficha ya quedó por encima de la pantalla.
    // Se oculta al volver arriba y al llegar al footer. Se calcula por posición en cada scroll
    // (un IntersectionObserver no avisa si un salto de scroll lleva el botón de abajo a arriba
    // sin haber pasado por la pantalla).
    // En móvil/tablet la barra está siempre visible; en desktop depende del scroll.
    var footer = doc.getElementById('t4s-footer');
    var refresh = function () {
      var show;
      if (isMobile()) {
        show = true;
      } else {
        var btn = mainAtc();
        var passed = btn ? btn.getBoundingClientRect().bottom < 0 : window.scrollY > window.innerHeight * 0.8;
        var footerIn = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
        show = passed && !footerIn;
      }
      if (show === cta.classList.contains('is-visible')) return;
      cta.classList.toggle('is-visible', show);
      cta.setAttribute('aria-hidden', show ? 'false' : 'true');
      setHeight();
    };
    onScrollFrame(refresh);
    window.addEventListener('resize', refresh, { passive: true });
  }

  /* ------------------------------------------------------------------------
     3. Reveal on scroll
     ------------------------------------------------------------------------ */
  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var main = doc.getElementById('MainContent');
    if (!main) return;

    var vh = window.innerHeight;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('is-in');
        // Quitar las clases al terminar: el transform no debe quedar como
        // bloque contenedor de elementos position:fixed dentro de la sección.
        setTimeout(function () {
          el.classList.remove('ghc-rv', 'is-in');
          el.querySelectorAll('.ghc-rv-item').forEach(function (it) {
            it.classList.remove('ghc-rv-item');
            it.style.removeProperty('--ghc-i');
          });
        }, 1600);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });

    sections.forEach(function (sec) {
      var rect = sec.getBoundingClientRect();
      if (rect.top < vh || rect.height === 0) return;           // visible al cargar: no tocar (LCP/CLS)
      if (sec.querySelector('.t4s-pf, [data-sticky-addtocart], video[autoplay]')) return;
      sec.classList.add('ghc-rv');
      var items = sec.querySelectorAll('.t4s-product, .t4s-col-item');
      for (var i = 0; i < items.length && i < 8; i++) {
        items[i].classList.add('ghc-rv-item');
        items[i].style.setProperty('--ghc-i', i);
      }
      io.observe(sec);
    });
  }

  /* ------------------------------------------------------------------------
     4. Microinteracciones (ripple + magnético)
     ------------------------------------------------------------------------ */
  var RIPPLE_SEL = '.t4s-btn, .ghc-cta__btn, .ghc-h-cta, .ghc-404__btn, button[type="submit"]';

  function initMicro() {
    root.classList.add('ghc-micro');
    if (reduceMotion) return;

    doc.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest && e.target.closest(RIPPLE_SEL);
      if (!btn || btn.disabled) return;
      var cs = getComputedStyle(btn);
      if (cs.position === 'static') btn.style.position = 'relative';
      if (cs.overflow !== 'hidden') btn.style.overflow = 'hidden';
      var r = btn.getBoundingClientRect();
      var size = Math.max(r.width, r.height) * 2;
      var dot = doc.createElement('span');
      dot.className = 'ghc-ripple';
      dot.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (e.clientX - r.left - size / 2) + 'px;top:' + (e.clientY - r.top - size / 2) + 'px';
      btn.appendChild(dot);
      setTimeout(function () { dot.remove(); }, 650);
    });

    if (!finePointer) return;

    // Efecto magnético sutil en CTAs principales
    doc.querySelectorAll('.ghc-404__btn--primary, [data-ghc-magnetic]').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        btn.style.transform = 'translate(' + (x * 8).toFixed(1) + 'px,' + (y * 6).toFixed(1) + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });
  }

  /* ------------------------------------------------------------------------
     5. Modo oscuro
     ------------------------------------------------------------------------ */
  function luminance(rgb) {
    var m = rgb && rgb.match(/[\d.]+/g);
    if (!m || m.length < 3) return null;
    if (m.length > 3 && parseFloat(m[3]) < 0.5) return null;            // casi transparente
    var c = m.slice(0, 3).map(function (v) {
      v = v / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }

  var SKIP_DARK = 'img, svg, video, picture, iframe, canvas, .ghc-cta, .ghc-h-cta, .ghc-theme-toggle, .gh-wa-float, .t4s-btn, .t4s-badge, [class*="__badge"], [class*="-badge"]';
  var HEADINGS = /^H[1-6]$/;

  // Fondo "efectivo" de un elemento: el del primer ancestro pintado.
  // 'light' = claro (se oscurece), 'mid' = tono medio/imagen (se respeta), 'dark' = ya oscuro.
  function surfaceOf(el, info) {
    for (var n = el; n && n !== doc.documentElement; n = n.parentElement) {
      var s = info.get(n);
      if (!s) {
        var cs = getComputedStyle(n);
        s = { img: cs.backgroundImage !== 'none' && cs.backgroundImage.indexOf('gradient') === -1, bl: luminance(cs.backgroundColor) };
        info.set(n, s);
      }
      if (s.img) return 'mid';
      if (s.bl !== null) return s.bl > 0.72 ? 'light' : (s.bl > 0.2 ? 'mid' : 'dark');
    }
    return 'light';
  }

  function darkPass(scope) {
    if (root.getAttribute('data-theme') !== 'dark') return;
    var nodes = scope ? [scope].concat(Array.prototype.slice.call(scope.querySelectorAll('*'))) : doc.body.querySelectorAll('*');
    var info = new Map();
    var writes = [];
    var bcs = getComputedStyle(doc.body);
    info.set(doc.body, { img: false, bl: luminance(bcs.backgroundColor) });

    // Fase 1: solo lectura (evita recalcular estilos en cada elemento)
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest(SKIP_DARK)) continue;
      var cs = getComputedStyle(el);
      var s = { img: cs.backgroundImage !== 'none' && cs.backgroundImage.indexOf('gradient') === -1, bl: luminance(cs.backgroundColor) };
      info.set(el, s);
      var add = [];
      if (!s.img && s.bl !== null && s.bl > 0.72) {
        add.push(el.matches('#MainContent > .shopify-section, #MainContent > .shopify-section > *') ? 'ghc-dk-bg--page' : 'ghc-dk-bg');
      }
      var tl = luminance(cs.color);
      if (tl !== null && tl < 0.25) add.push(HEADINGS.test(el.tagName) ? 'ghc-dk-hd' : 'ghc-dk-tx');
      if (cs.borderTopStyle !== 'none' && cs.borderTopWidth !== '0px' && luminance(cs.borderTopColor) > 0.72) add.push('ghc-dk-bd');
      if (add.length) writes.push([el, add]);
    }

    // Fase 2: escritura. El texto oscuro solo se aclara si su fondo real se oscurece.
    writes.forEach(function (w) {
      var el = w[0];
      var cls = w[1].filter(function (c) {
        if (c !== 'ghc-dk-tx' && c !== 'ghc-dk-hd') return true;
        return surfaceOf(el, info) !== 'mid';
      });
      if (cls.length) el.classList.add.apply(el.classList, cls);
    });
  }

  function clearDark() {
    doc.querySelectorAll('.ghc-dk-bg, .ghc-dk-bg--page, .ghc-dk-tx, .ghc-dk-hd, .ghc-dk-bd').forEach(function (el) {
      el.classList.remove('ghc-dk-bg', 'ghc-dk-bg--page', 'ghc-dk-tx', 'ghc-dk-hd', 'ghc-dk-bd');
    });
  }

  function swapLogos(dark) {
    doc.querySelectorAll('.t4s-header__logo img').forEach(function (img) {
      if (cfg.darkLogo) {
        if (dark) {
          if (!img.dataset.ghcLight) img.dataset.ghcLight = img.currentSrc || img.src;
          img.removeAttribute('srcset');
          img.src = cfg.darkLogo;
        } else if (img.dataset.ghcLight) {
          img.src = img.dataset.ghcLight;
        }
      } else {
        img.classList.toggle('ghc-logo-invert', dark);
      }
    });
  }

  function applyTheme(mode, animate) {
    if (animate && !reduceMotion) {
      root.classList.add('ghc-theme-anim');
      setTimeout(function () { root.classList.remove('ghc-theme-anim'); }, 450);
    }
    if (mode === 'dark') root.setAttribute('data-theme', 'dark');
    else root.removeAttribute('data-theme');
    var dark = mode === 'dark';
    doc.querySelectorAll('[data-ghc-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      b.setAttribute('aria-label', dark ? cfg.i18n.lightMode : cfg.i18n.darkMode);
      b.title = dark ? cfg.i18n.lightMode : cfg.i18n.darkMode;
    });
    var meta = doc.querySelector('meta[name="theme-color"]');
    if (meta) {
      if (!meta.dataset.ghcLight) meta.dataset.ghcLight = meta.content;
      meta.content = dark ? '#151918' : meta.dataset.ghcLight;
    }
    swapLogos(dark);
    if (dark) setTimeout(function () { darkPass(); }, 0);
    else clearDark();
  }

  function initDarkMode() {
    var toggles = doc.querySelectorAll('[data-ghc-theme-toggle]');
    if (!toggles.length) return;
    root.classList.add('ghc-theme-on');
    applyTheme(store('ghc-theme') === 'dark' ? 'dark' : 'light', false);

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        store('ghc-theme', next);
        applyTheme(next, true);
        pushEvent('ghc_theme_toggle', { theme: next });
      });
    });

    // Contenido inyectado después (drawers, carrito, quick view, apps)
    var pending = [];
    var timer = null;
    new MutationObserver(function (muts) {
      if (root.getAttribute('data-theme') !== 'dark') return;
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && !n.classList.contains('ghc-ripple')) pending.push(n); });
      });
      if (!pending.length || timer) return;
      timer = setTimeout(function () {
        var list = pending.splice(0);
        timer = null;
        list.forEach(function (n) { if (n.isConnected) darkPass(n); });
      }, 120);
    }).observe(doc.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------------
     6. Consentimiento (Shopify Customer Privacy API + dataLayer para GTM)
     ------------------------------------------------------------------------ */
  function pushEvent(name, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: name };
    for (var k in data) payload[k] = data[k];
    window.dataLayer.push(payload);
  }

  function gtagConsent(granted) {
    window.dataLayer = window.dataLayer || [];
    var v = granted ? 'granted' : 'denied';
    // Mismo formato que gtag(): GTM lo interpreta como actualización de Consent Mode
    window.dataLayer.push(['consent', 'update', {
      ad_storage: v, ad_user_data: v, ad_personalization: v, analytics_storage: v
    }]);
    pushEvent('ghc_consent', { consent: v });
  }

  // Sin banner: el consentimiento se concede siempre, para que la analítica y los píxeles
  // funcionen desde la primera visita sin depender de un clic del visitante.
  function initConsent() {
    gtagConsent(true);

    function grant(api) {
      if (!api || !api.setTrackingConsent) return;
      // Shopify lo guarda en su propia cookie first-party (≈1 año) y la renueva desde el
      // servidor: si ya está dado, no hace falta repetir la llamada en cada página.
      var current = null;
      if (api.currentVisitorConsent) {
        try { current = (api.currentVisitorConsent() || {}).analytics || null; } catch (e) {}
      }
      if (current === 'yes') return;
      try {
        api.setTrackingConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: true }, function () {});
      } catch (e) {}
    }

    // Carga bajo demanda de la Customer Privacy API de Shopify (la que enciende de verdad los píxeles).
    if (window.Shopify && window.Shopify.customerPrivacy) return grant(window.Shopify.customerPrivacy);
    if (!(window.Shopify && window.Shopify.loadFeatures)) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) grant(window.Shopify.customerPrivacy);
    });
  }

  /* ------------------------------------------------------------------------
     7. Animaciones de carga
     ------------------------------------------------------------------------ */
  function initLoading() {
    var splash = doc.querySelector('[data-ghc-splash]');
    if (splash) {
      var done = function () { splash.classList.add('is-done'); setTimeout(function () { splash.remove(); }, 600); };
      if (doc.readyState === 'complete') done();
      else { window.addEventListener('load', done); setTimeout(done, 1800); }
    }

    var bar = doc.querySelector('[data-ghc-navbar]');
    if (!bar) return;
    doc.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript|sms):/i.test(href)) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      // Los links que abren drawers/popups del theme hacen preventDefault después; comprobamos en el siguiente tick
      setTimeout(function () { if (!e.defaultPrevented) bar.classList.add('is-loading'); }, 0);
    });
    window.addEventListener('pageshow', function () { bar.classList.remove('is-loading'); });
  }

  /* ------------------------------------------------------------------------
     Init
     ------------------------------------------------------------------------ */
  function init() {
    if (cfg.progress) initProgress();
    if (cfg.cta) initCta();
    if (cfg.reveal) initReveal();
    if (cfg.micro) initMicro();
    if (cfg.dark) initDarkMode();
    initConsent();
    initLoading();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();
